import React from 'react'
import { ComingSoon } from './tabs'

const ThreeFeatures = ({ block }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className="container">
      <div className="row">
        <div className="col-lg-6 col-md-5 image">
        {block.image && (
          <img className={`card-image${block.hide_image_on_mobile ? ' is-desktop' : ''}`} src={block.image} alt={block.image_alt_text} title={block.image_alt_text} />
        )}
        </div>
        
        <div className="col-lg-6 col-md-7 text">
          <div className="row">
            {block.features.map((feature, index) => {
              return <div key={index} className="col-12 feature">
                <div className="card">
                  <div className="hover"><span className='circle blue'></span><span className='circle orange'></span></div>
                  {feature.icon && (
                    <img src={feature.icon} alt={block.image_alt_text} title={block.image_alt_text} />
                  )}
                  <div className="content-wr">
                    {feature.title && (
                      <div className='title-wr'>
                        <h4 dangerouslySetInnerHTML={{__html: feature.title}}></h4>
                        <ComingSoon style={feature.style} />
                      </div>
                    )}
                    {feature.text && ( <div className="text-formatted" dangerouslySetInnerHTML={{__html: feature.text}}></div> )}
                  </div>
                </div>
              </div>
            })}
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default ThreeFeatures
